import { createSlice } from "@reduxjs/toolkit";
import {
  createMultipleFrasesConfirmacionPlantelThunk,
  getFraseConfirmacionPlantelByIdThunk,
  getFrasesConfirmacionPlantelThunk,
  toggleFraseConfirmacionPlantelActiveThunk,
  updateFraseConfirmacionPlantelThunk,
} from "./Frasesconfirmacionplantel.thunks";

const initialState = {
  list: [],
  loading: false,
  error: null,
  page: 1,
  pageSize: 10,
  totalPages: 1,
  count: 0,
  next: null,
  previous: null,
  maxPageReached: 1,
  search: "",
  talentoFilter: "",
  preguntaFilter: "",

  selectedFrase: null,
  selectedFraseLoading: false,
  selectedFraseError: null,
  viewModalOpen: false,

  formModalOpen: false,
  formMode: "create", // "create" | "edit"
  formLoading: false,
  formError: null,

  confirmModalOpen: false,
  toggleFraseId: null,
  toggling: false,
};

const frasesConfirmacionPlantelSlice = createSlice({
  name: "frasesConfirmacionPlantel",
  initialState,
  reducers: {
    clearFrasesConfirmacionPlantelError: (state) => {
      state.error = null;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setSearch: (state, action) => {
      state.search = action.payload;
      state.page = 1;
    },
    setTalentoFilter: (state, action) => {
      state.talentoFilter = action.payload;
      state.page = 1;
    },
    setPreguntaFilter: (state, action) => {
      state.preguntaFilter = action.payload;
      state.page = 1;
    },
    clearFilters: (state) => {
      state.search = "";
      state.talentoFilter = "";
      state.preguntaFilter = "";
      state.page = 1;
    },
    resetFrasesConfirmacionPlantel: () => initialState,
    openViewModal: (state) => {
      state.viewModalOpen = true;
    },
    closeViewModal: (state) => {
      state.viewModalOpen = false;
      state.selectedFrase = null;
    },
    openFormModal: (state, action) => {
      state.formModalOpen = true;
      state.formMode = action.payload?.mode || "create";
      if (action.payload?.frase) {
        state.selectedFrase = action.payload.frase;
      }
      state.formError = null;
    },
    closeFormModal: (state) => {
      state.formModalOpen = false;
      state.selectedFrase = null;
      state.formError = null;
    },
    openConfirmToggle: (state, action) => {
      state.confirmModalOpen = true;
      state.toggleFraseId = action.payload.id;
    },
    closeConfirmToggle: (state) => {
      state.confirmModalOpen = false;
      state.toggleFraseId = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // GET ALL
      .addCase(getFrasesConfirmacionPlantelThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getFrasesConfirmacionPlantelThunk.fulfilled, (state, action) => {
        const { results, count, next, previous } = action.payload;
        state.loading = false;
        state.list = results;
        state.count = count;
        state.next = next;
        state.previous = previous;
        state.maxPageReached = Math.max(state.maxPageReached, state.page);
      })
      .addCase(getFrasesConfirmacionPlantelThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // CREATE MULTIPLE
      .addCase(
        createMultipleFrasesConfirmacionPlantelThunk.pending,
        (state) => {
          state.formLoading = true;
          state.formError = null;
        },
      )
      .addCase(
        createMultipleFrasesConfirmacionPlantelThunk.fulfilled,
        (state) => {
          state.formLoading = false;
          state.formModalOpen = false;
        },
      )
      .addCase(
        createMultipleFrasesConfirmacionPlantelThunk.rejected,
        (state, action) => {
          state.formLoading = false;
          state.formError = action.payload;
        },
      )

      // GET BY ID
      .addCase(getFraseConfirmacionPlantelByIdThunk.pending, (state) => {
        state.selectedFraseLoading = true;
        state.selectedFraseError = null;
      })
      .addCase(
        getFraseConfirmacionPlantelByIdThunk.fulfilled,
        (state, action) => {
          state.selectedFraseLoading = false;
          state.selectedFrase = action.payload;
        },
      )
      .addCase(
        getFraseConfirmacionPlantelByIdThunk.rejected,
        (state, action) => {
          state.selectedFraseLoading = false;
          state.selectedFraseError = action.payload;
        },
      )

      // UPDATE
      .addCase(updateFraseConfirmacionPlantelThunk.pending, (state) => {
        state.formLoading = true;
        state.formError = null;
      })
      .addCase(
        updateFraseConfirmacionPlantelThunk.fulfilled,
        (state, action) => {
          state.formLoading = false;
          const index = state.list.findIndex((f) => f.id === action.payload.id);
          if (index !== -1) {
            state.list[index] = action.payload;
          }
          state.formModalOpen = false;
        },
      )
      .addCase(
        updateFraseConfirmacionPlantelThunk.rejected,
        (state, action) => {
          state.formLoading = false;
          state.formError = action.payload;
        },
      )

      // TOGGLE ACTIVE
      .addCase(toggleFraseConfirmacionPlantelActiveThunk.pending, (state) => {
        state.toggling = true;
      })
      .addCase(
        toggleFraseConfirmacionPlantelActiveThunk.fulfilled,
        (state, action) => {
          state.toggling = false;
          state.confirmModalOpen = false;
          const index = state.list.findIndex((f) => f.id === action.payload.id);
          if (index !== -1) {
            state.list[index] = action.payload;
          }
        },
      )
      .addCase(
        toggleFraseConfirmacionPlantelActiveThunk.rejected,
        (state, action) => {
          state.toggling = false;
          state.error = action.payload;
        },
      );
  },
});

export const {
  clearFrasesConfirmacionPlantelError,
  setPage,
  setSearch,
  setTalentoFilter,
  setPreguntaFilter,
  clearFilters,
  resetFrasesConfirmacionPlantel,
  openViewModal,
  closeViewModal,
  openFormModal,
  closeFormModal,
  openConfirmToggle,
  closeConfirmToggle,
} = frasesConfirmacionPlantelSlice.actions;

export default frasesConfirmacionPlantelSlice.reducer;
